import { TieBreakerLineupVisibility } from '@/entities/season-division/SeasonDivisionPool';

export const isTieBreakerLineupVisibleWhenNeeded = (visibility: TieBreakerLineupVisibility): boolean => {
	return visibility === TieBreakerLineupVisibility.TIE_BREAKER_LINEUP_OPTION_ONCE_TIE_BREAKER_IS_NEEDED;
};

/**
 * Checks whether the lineup visibility is set to manual
 */
export const isManualOption = (visibility: TieBreakerLineupVisibility): boolean => {
	return visibility === TieBreakerLineupVisibility.TIE_BREAKER_LINEUP_OPTION_MANUAL;
};

/**
 * Checks if the manual option is active and a publish date is set
 */
export const hasPublishedManualDate = (visibility: TieBreakerLineupVisibility, publishedDate: string | null): boolean => {
	return isManualOption(visibility) && Boolean(publishedDate);
};

export const shouldBlurTieBreakerLineup = (
	visibility: TieBreakerLineupVisibility,
	publishedDate: string | null,
	hasLineupAccess: boolean
): boolean => {
	return (
		(isTieBreakerLineupVisibleWhenNeeded(visibility) && !hasLineupAccess) ||
		(isManualOption(visibility) && !hasPublishedManualDate(visibility, publishedDate) && !hasLineupAccess)
	);
};
